export default {
    name    : "with-validation",
    props   : ['field'],
    data    : () => ({
        validationRoot: null
    }),
    methods : {
        findValidationRoot() {
            let parent = this.$parent;
            while (!parent.$data.v__isValidatable) {
                parent = parent.$parent;
            }
            this.validationRoot = parent;
        }
    },
    computed: {
        inputLabel() {
            return this.validationRoot?.v__context?.fields[this.field];
        },
        hasError() {
            return this.validationRoot?.v__hasError(this.field);
        },
        errors() {
            return this.validationRoot?.v__getErrors(this.field);
        },
        validate() {
            return this.validationRoot?.validate([this.field]);
        },
        model() {
            return this.validationRoot?.v__model;
        },
        fieldValue: {
            get() {
                return _.get(this.model, this.field);
            },
            set(value) {
                _.set(this.model, this.field, value);
            }
        }
    },
    render() {

        return this.$scopedSlots.default({
            bind: {
                error        : this.hasError,
                errorMessages: this.errors,
                hideDetails  : !this.hasError,
                value        : this.fieldValue,
                label        : this.inputLabel
            },
            on  : {
                // blur  : () => {
                //     this.validationRoot.validate([this.field]);
                // },
                change: (newVal) => {
                    this.fieldValue = newVal;
                    this.validationRoot.validate([this.field]);
                },
                input : (newVal) => {
                    this.fieldValue = newVal;
                }
            }
        })
    },
    mounted() {
        this.findValidationRoot();
    }
}
